import React, {
    createContext, Fragment, useReducer
} from 'react';
import Alert from "@material-ui/lab/Alert";
import Snackbar from "@material-ui/core/Snackbar";

const defaultSettings = {
    opened: false,
    text: '',
    type: 'success',
    onClose: null
};

export const AlertReducer = (state, action) => {

    switch (action.action) {
        case 'close':
            if (state.onClose) {
                state.onClose();
            }
            return Object.assign({}, state, { opened: false, text: '', onClose: null });
        case 'open':
            window.scrollTo();
            return Object.assign({}, state, { opened: true, type: action.type, text: action.text, onClose: action.onClose });
    }
    return Object.assign({}, state);
};

export const AlertContext = createContext(defaultSettings);

export const AlertProvider = ({  settings, children }) => {
    const [state, dispatch] = useReducer(AlertReducer, defaultSettings);

    const handleClose = () => {
        dispatch({ action: 'close' });
    }

    const showSuccess = (text, onClose) => {
        dispatch({ action: 'open', text: text, type: 'success', onClose: onClose });
    }

    const showError = (text, onClose) => {
        dispatch({ action: 'open', text: text, type: 'error', onClose: onClose });
    }

	return (

    <Fragment>
      <AlertContext.Provider value={{showSuccess, showError, state, dispatch}}>
        {children}
        <Snackbar open={state.opened} autoHideDuration={6000} onClose={handleClose}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}>
          <Alert onClose={handleClose} severity={state.type}>
              {state.text}
          </Alert>
        </Snackbar>
      </AlertContext.Provider>

    </Fragment>
	);
};